
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import CourseCard from './CourseCard.vue'
import type { CalligraphyLevel2JsonResp, CourseItem } from '@xt/client/utils/activities/types'
import { Observer } from 'mobx-vue'
import { EnumActivityCourseTip } from '@xt/client/enums/activity'

@Observer
@Component({
  components: {
    LazyImg,
    CourseCard
  }
})
export default class Courses extends Vue {
  @Prop({ default: () => [] }) readonly courses!: Array<CourseItem>
  @Prop({ required: true }) readonly labels!: CalligraphyLevel2JsonResp['labels']

  popLabels: {
    live: string
    practice: string
    adult: string
  } = {
    live: '',
    practice: '',
    adult: ''
  }

  get EnumActivityCourseTip() {
    return EnumActivityCourseTip
  }

  created(): void {
    this.popLabels = {
      live: this.labels.live ?? '',
      practice: this.labels.practice ?? '',
      adult: this.labels.adult ?? ''
    }
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
